import { TextField } from "@mui/material";

const InputComponent = (props: any) => (
    <TextField
      fullWidth
      id={`outlined-${props?.name || props?.elementName}`}
      label={`${props?.name || props?.elementName || ""} ${props?.checklistItem?.isRequired ? "*" : ""}`.trim()}
      onChange={props?.onChange}
    />
  );

export default InputComponent;
